<template>
  <div style="position: relative; width: 25%">
    <div v-if="custom">
      <div>
        <slot></slot>
      </div>
    </div>
    <div v-else>
      <!-- 不管是app还是公众号，为保证按钮效果统一，这里全都显示按钮 -->
      <div class="applet-menu-content" :style="customStyle">
        <p>{{name}}</p>
      </div>
      <!-- 给公众号上面加一层透明遮罩层 -->
      <div
        style="
          position: absolute;
          background: #fff;
          opacity: 0;
          width: 100px;
          height: 100px;
          top: 0;
          left: 0;
        "
      >
        <wx-open-launch-weapp
          id="launch-btn"
          :appid="appid"
          :username="userName"
          :path="path"
          @launch="handleLaunchFn"
          @error="handleErrorFn"
        >
          <script type="text/wxtag-template">
            <style>
            </style>
            <div style="width: 100px; height: 100px; border: none; background: #fff;"/>
          </script>
        </wx-open-launch-weapp>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // 菜单名称
    name: {
      type: String,
      default: function () {
        return '';
      }
    },
    // 菜单图标（require('XXX')的方式传参，避免路径不一致）
    iconSrc: {
      type: String,
      default: function () {
        return '';
      }
    },
    // 跳转小程序的appid
    appid: {
      type: String,
      default: function () {
        return '';
      }
    },
    // 跳转小程序的原始ID
    userName: {
      type: String,
      default: function () {
        return '';
      }
    },
    // 跳转小程序的页面路径
    path: {
      type: String,
      default: function () {
        return '';
      }
    },
    custom: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    customStyle() {
      return {
        backgroundImage: `url(${this.iconSrc})`
      }
    }
  },
  mounted () {
    console.log('channel', this.channel)
  },
  data: function () {
    return {

    };
  },
  methods: {
    handleLaunchFn (e) {
      console.log('handleLaunchFn e = ', e)
    },
    handleErrorFn (e) {
      console.log('handleErrorFn e = ', e);
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../../static/sass/_variable.scss";
.applet-menu-content {
  width: 100%;
  padding-top: 40px;
  background-size: auto 50%;
  background-position: top center;
  background-repeat: no-repeat;
  font-size: 13px;
  line-height: 22px;
  text-align: center;
  margin-top: 20px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// AppletIconMenu.vue?4d91196a